// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class PostAPI extends MainAPI {
	/** 
	 * @param {*} postDetails
	 */
	async createPost(postDetails) {
		const newFormData = new FormData();
		const { images, formDetails } = postDetails;

		newFormData.append(
			'formData',
			JSON.stringify(formDetails)
		);

		if (images.length > 0) {
			images.forEach(image => {
				newFormData.append(
					'images',
					image
				);
			});
		}

		return API.post(ENDPOINTS.CREATE_POST, newFormData, { timeout: 180000 });
	}

	/** 
	 * @param {Number} options - Option of the request
	 */
	async getPostById(postId) {
		return API.get(`${ENDPOINTS.GET_POSTS}/${postId}`);
	}

	/** 
	 * @param {Object} options - Option of the request
	 * @param {Number} options.breedId - Breed Id
	 * @param {('health' | 'exercise' | 'behaviour' | 'general')} options.topic - Topic
	 * @param {Number} options.offset - Offset
	 * @param {Number} options.limit - Limit
	 */
	async getPosts(options) {
		return API.get(ENDPOINTS.GET_POSTS, options);
	}

	/** 
	 * @param {Number} postId - element id of the post.
	 */
	async deletePost(postId) {
		return API.delete(`${ENDPOINTS.DELETE_POST}/${postId}`);
	}

	/** 
	 * @param {*} postDetails
	 */
	async updatePost(postDetails) {
		const newFormData = new FormData();
		const { images, formDetails } = postDetails;

		newFormData.append(
			'formData',
			JSON.stringify(formDetails)
		);

		if (images.length > 0) {
			images.forEach(image => {
				newFormData.append(
					'images',
					image
				);
			});
		}

		return API.patch(ENDPOINTS.PATCH_POST, newFormData, { timeout: 180000 });
	}
}

export default new PostAPI();
